import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {BetweenDates, Unavailability, UnavailabilityRequest} from '../models/eventRequest';
import {DateService} from './date.service';

const API = environment.APIEndpoint + '/api/unavailabilities';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

/** Indisponibilités des moniteurs (congé, rendez-vous...). */
@Injectable({
  providedIn: 'root'
})
export class UnavailabilityService {

  constructor(private http: HttpClient, private dateService: DateService) { }

  list(dates: BetweenDates, monitorId?: string): Observable<Unavailability[]> {
    const params = monitorId ? '?monitorId=' + monitorId : '';
    return this.http.post<Unavailability[]>(API + '/between-dates' + params, this.dateService.getBetweenDatesString(dates), httpOptions);
  }

  create(request: UnavailabilityRequest): Observable<Unavailability> {
    return this.http.post<Unavailability>(API, request, httpOptions);
  }

  update(id: number, request: UnavailabilityRequest): Observable<Unavailability> {
    return this.http.put<Unavailability>(API + '/' + id, request, httpOptions);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(API + '/' + id);
  }
}
